import Routes from "./routes";

import "./styles/reset.css";
import "./assets/fonts/bmw-icons/bmw-icons.css";
import "./styles/global.css";

function App() {
	return <Routes />;
}

export default App;
